/** Snap radius in screen pixels; divided by zoom to get the artwork space threshold. */
export const SNAP_SCREEN_PX = 5;

export interface SnapResult {
  /** How far to shift the box so an edge or its centre lands on a target. */
  offset: number;
  /** The target that matched, for drawing the guide line. */
  guide: number | null;
}

export function snapAxis(edges: number[], targets: number[], threshold: number): SnapResult {
  let best: SnapResult | null = null;
  for (const edge of edges) {
    for (const target of targets) {
      const offset = target - edge;
      if (Math.abs(offset) > threshold) continue;
      if (!best || Math.abs(offset) < Math.abs(best.offset)) best = { offset, guide: target };
    }
  }
  return best ?? { offset: 0, guide: null };
}

export function boxEdges(start: number, size: number): number[] {
  return [start, start + size / 2, start + size];
}

export interface SnapAxes {
  xs: number[];
  ys: number[];
}

/** Artwork edges, its centre lines, and every map seam, which is where alignment actually matters. */
export function frameTargets(width: number, length: number, mapSize: number): SnapAxes {
  const xs = [0, width / 2, width];
  const ys = [0, length / 2, length];
  for (let x = mapSize; x < width; x += mapSize) xs.push(x);
  for (let y = mapSize; y < length; y += mapSize) ys.push(y);
  return { xs, ys };
}
